function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.496 15.26l.052.007c.295.088.61.088.904 0a.166.166 0 01.214.16v2.74a.5.5 0 101 0 .667.667 0 111.333 0 1.833 1.833 0 11-3.665 0v-2.74a.166.166 0 01.214-.16zM12 4c.368 0 .666.298.666.667v.215c0 .086.065.157.15.165a8.11 8.11 0 017.18 8.286v.334a.667.667 0 11-1.332 0c0-.356-.467-.667-1-.667-.533 0-1 .311-1 .667a.667.667 0 11-1.332 0c0-.272-.52-.667-1.333-.667s-1.333.395-1.333.667a.667.667 0 11-1.332 0c0-.272-.52-.667-1.333-.667-.814 0-1.333.395-1.333.667a.667.667 0 11-1.333 0c0-.356-.466-.667-1-.667-.532 0-.999.311-.999.667a.667.667 0 11-1.333 0v-.334a8.11 8.11 0 017.18-8.286.166.166 0 00.15-.165v-.215c0-.369.299-.667.667-.667z"
});

function SvgUmbrella(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgUmbrella;